export default {
  HeaderContent: {
    Heading: 'Choose from Tons of Proven, ATS-Friendly Templates',
    Description:
      'Wisedoc will walk you through from beginning to end, and templates are just some layouts to save your time from needless formatting.',
  },
  TabContent: {
    ResumeTabText: 'Resume',
    CoverLetterTabText: 'Cover Letter',
  },
  formatType: {
    RESUME: 'resumes',
    COVER_LETTER: 'coverLetters',
  },
};
